import React from 'react'
import { useLaunchModalContext } from '../../../../contexts/LaunchModalContext'
import { ProgressDotContainer, ProgressDotComplete } from './style'

interface CarouselProgressDotProps {
  ariaLabel?: string
  progressIndex: number
}

const CarouselProgressDot: React.VFC<CarouselProgressDotProps> = ({ ariaLabel = '', progressIndex }) => {
  const { activeIndex, dataTaktId, goToSlide } = useLaunchModalContext()
  return (
    <ProgressDotContainer onClick={() => goToSlide(progressIndex)} aria-label={ariaLabel} data-takt-id={`${dataTaktId}_progress-dot-${progressIndex}`}>
      {progressIndex <= activeIndex ? <ProgressDotComplete /> : null}
    </ProgressDotContainer>
  )
}

export default CarouselProgressDot
